import React from 'react';

function StoryContentTextOnly({ content }) {
  if (!content) return null;

  return (
    <div className="story-content-text-only-container">
      <div className="decorative-quote decorative-quote-open">"</div>
      <div className="story-content-text-only">
        {content.split('\n').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
      <div className="decorative-quote decorative-quote-close">"</div>
    </div>
  );
}

export default StoryContentTextOnly;
